var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.125 10.581l-2.771 2.772-.708-.706 2.772-2.773a6 6 0 1 1 .707.707zm.572-.827a5 5 0 1 0-.45-.449l.45.449z", fill: "#000", fillRule: "evenodd" })
  );
});